import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";

export class NotificationsService {
  public message: string = '';
  public type: string = '';

  constructor(private $rootScope: ng.IRootScopeService) { }

  sendMessage(msg: string, type: string): void {
    this.message = msg;
    this.type = type;
    this.broadcastItem();
  }

  closeMessage(): void {
    this.message = '';
    this.type = '';
    this.broadcastItem('closeMessage');
  }

  private broadcastItem(action: string = 'showMessage'): void {
    this.$rootScope.$broadcast(action);
  }
}

angularJsApp.service(AppServicesEnum.NOTIFICATIONS_SERVICE, NotificationsService);
